export const menuItems = [
  {
    name: 'Population',
    countKey: 'narwhals',
    route: 'population'
  },
  {
    name: 'MySwarm',
    countKey: 'swarm',
    route: 'my-swarm',
    needAuth: true
  },
  {
    name: 'CRISPRLab',
    countKey: 'crisprParts',
    route: 'crispr'
  },
  {
    name: 'Exchange',
    countKey: 'glitterOffers',
    route: 'exchange'
  }
];